import tryCatch from 'ramda/src/tryCatch'
import reportError from 'root/src/shared/util/reportError'

// eslint-disable-next-line max-len
export default () => (global.window
	? tryCatch(
		() => window.location.pathname + window.location.search + window.location.hash, reportError,
	)(undefined)
	: undefined)
